import { delay } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { pageContext, get } from 'ctm-util-functions';
import {
    getJourneyPayload,
    getLeadPayload,
    getMarketingRequestPayload,
    getProductPayload
} from './state_selectors';

import {
    logPayloadError,
    processErrorActions,
    processRequestAndActionsSaga,
    processRedirect,
    processSagaWithRetries
} from './utils';

/**
 * Process the Post and Get Payload action. i.e POST_PAYLOAD, GET_PAYLOAD, etc.
 * Find the payload for the request and catches any error while getting it.
 * Calls to the "processSagaWithRetries" generator to process the main Request and its actions in a loop using the request payload.
 * Process the redirects set on the schema when the action succeed.
 * @param {Object} action - The action that describes the request.
 */
export const processPayloadIfTransactionAction = function* (action) {
    const { apiSchema } = action;
    const retry = 5;

    if (!apiSchema) {
        return;
    }

    for (let i = 0; i < retry; i += 1) {
        const journeyPayload = yield select(getJourneyPayload);
        if (journeyPayload.transaction) {
            let requestPayload = null;

            // Clear the current state error before getting the payload or sending the request.
            yield put({ type: 'CLEAR_CURRENT_ERROR' });

            // Set the request Payload before fetching any request. This prevents to change the payload while fetching the request.
            if (apiSchema.requestPayload) {
                const verticalPayloadSelectors = get(pageContext.getProps().verticalSelectors, 'payloadSelectors', {});
                try {
                    // Available Payloads.
                    const PAYLOADS = {
                        journey: getJourneyPayload,
                        product: getProductPayload,
                        lead: getLeadPayload,
                        marketing: getMarketingRequestPayload,
                        ...verticalPayloadSelectors
                    };
                    if (!PAYLOADS[apiSchema.requestPayload]) {
                        throw Error(`Request Payload passed in does not exist: ${apiSchema.requestPayload}`);
                    }
                    // Get the payload for the action request.
                    requestPayload = yield select(PAYLOADS[apiSchema.requestPayload], action);
                } catch (error) {
                    // Log the payload error and show the error modal.
                    yield call(logPayloadError, error, action, Date.now());
                    // Process the actions on error.
                    yield call(processErrorActions, error, action);
                    yield call(processRedirect, action, 'redirectOnError');
                    return;
                }
            } else if (action.requestPayload) {
                requestPayload = action.requestPayload;
            }

            // Process and retry (if failed) the request set on the requestAction property using the payload and its actions.
            yield call(processSagaWithRetries, processRequestAndActionsSaga, action, requestPayload);

            // Redirect user to the page specified in the schema.
            yield call(processRedirect, action, 'redirectResponse');
            return;
        } if (i < (retry - 1)) {
            yield call(delay, 2000);
        } else {
            throw new Error('payload requires transaction');
        }
    }
};
